import React from 'react';
import CountUp from 'react-countup';

// Import images
import counterTwoBgShape from '../../assets/images/shapes/counter-two-bg-shape.png';
import counterTwoRightBgShape from '../../assets/images/shapes/counter-two-right-bg-shape.png';

const CounterTwo = () => {
  return (
    <>
      <section className="counter-two" id="waarom">
        <div className="counter-two__wrap">
          <div
            className="counter-two__bg-shape float-bob-y"
            style={{ backgroundImage: `url(${counterTwoBgShape})` }}
          ></div>
          <div className="container">
            <div className="section-title text-center">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">waarom <span className="nowrap">ART-WER</span></span>
              </div>
              <h2 className="section-title__title">
                Waarom klanten kiezen <br />voor <span className="nowrap">ART-WER</span>
              </h2>
            </div>
            <div className="row">
            <div className="col-xl-6 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                <div className="counter-two__left">
                  <ul className="counter-two__points-list list-unstyled">
                    <li>
                      <div className="icon">
                        <span className="icon-architect"></span>
                      </div>
                      <div className="content">
                        <h3>U praat met de vakman zelf</h3>
                        <p>
                          Geen verkoper, geen tussenpersoon. Wie de offerte maakt, voert ook het werk uit.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-blueprint"></span>
                      </div>
                      <div className="content">
                        <h3>Eenmanszaak sinds 2012</h3>
                        <p>
                          Geen overhead, geen logge organisatie — een eerlijke prijs en snel schakelen.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-wall"></span>
                      </div>
                      <div className="content">
                        <h3>Bewezen techniek</h3>
                        <p>
                          Soprema ALSAN® PMMA — geen experimenten met budgetalternatieven.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-6 wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
                <div className="counter-two__right">
                  <div
                    className="counter-two__right-bg-shape"
                    style={{ backgroundImage: `url(${counterTwoRightBgShape})` }}
                  ></div>
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-architect"></span>
                        </div>
                        <div className="counter-two__count-box">
                          <div className="counter-two__count count-box">
                            <div className="count-text">
                              <CountUp end={13} duration={1.5} />
                            </div>
                            <span>+</span>
                          </div>
                          <p className="counter-two__count-text">Jaar ervaring</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-paint-roller"></span>
                        </div>
                        <div className="counter-two__count-box">
                          <div className="counter-two__count count-box">
                            <div className="count-text">
                              <CountUp end={100} duration={1.5} />
                            </div>
                            <span>%</span>
                          </div>
                          <p className="counter-two__count-text">Eigen uitvoering</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-wall"></span>
                        </div>
                        <div className="counter-two__count-box">
                          <div className="counter-two__count count-box">
                            <div className="count-text">
                              <CountUp end={1} duration={1.5} />
                            </div>
                          </div>
                          <p className="counter-two__count-text">Vast aanspreekpunt</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-stairs"></span>
                        </div>
                        <div className="counter-two__count-box">
                          <div className="counter-two__count count-box">
                            <div className="count-text">
                              <CountUp end={0} duration={1.5} />
                            </div>
                          </div>
                          <p className="counter-two__count-text">Verrassingen achteraf</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CounterTwo;
